import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Eye, Sparkles, Camera } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const authHeaders = () => {
  const t = localStorage.getItem('session_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export default function ShareTrackingCard() {
  const [rows, setRows] = useState(null);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    fetch(`${API}/api/pollen/brochures/views-summary`, { credentials: 'include', headers: authHeaders() })
      .then((r) => (r.ok ? r.json() : { items: [] }))
      .then((d) => setRows(d.items || []))
      .catch(() => setRows([]));
  }, []);

  if (!rows || rows.length === 0) return null;
  const shown = showAll ? rows : rows.slice(0, 6);
  return (
    <Card data-testid="share-tracking-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm flex items-center gap-1.5">
          <Eye className="w-4 h-4 text-amber-700" />Shared Brochures &amp; Memories — Views
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-1.5">
        {shown.map((b) => (
          <div key={b.id} className="flex items-center gap-2 text-xs border-b border-dashed last:border-0 pb-1.5" data-testid={`share-track-row-${b.id}`}>
            {b.kind === 'memories' ? <Camera className="w-3 h-3 text-rose-600 shrink-0" /> : <Sparkles className="w-3 h-3 text-amber-700 shrink-0" />}
            <div className="flex-1 min-w-0">
              <p className="truncate font-medium">{b.title || 'Untitled'}</p>
              <p className="text-[10px] text-muted-foreground truncate">
                {b.owner_name || b.owner_kind}{b.last_viewed_at ? ` · last seen ${b.last_viewed_at.slice(0, 10)}` : ' · not viewed yet'}
              </p>
            </div>
            {!b.is_published && <Badge variant="outline" className="text-[9px]">Draft</Badge>}
            {b.views_7d > 0 && <Badge className="bg-emerald-100 text-emerald-800 text-[9px]">+{b.views_7d} this wk</Badge>}
            <span className="flex items-center gap-0.5 font-semibold text-amber-900 whitespace-nowrap"><Eye className="w-3 h-3" />{b.view_count || 0}</span>
          </div>
        ))}
        {rows.length > 6 && (
          <button type="button" className="text-[11px] text-amber-800 underline decoration-dotted" onClick={() => setShowAll(!showAll)} data-testid="share-track-toggle">
            {showAll ? 'Show less' : `Show all ${rows.length}`}
          </button>
        )}
      </CardContent>
    </Card>
  );
}
